module.exports = __webpack_public_path__ + "static/media/true.f1beff9c.svg";